<template>
  <el-dialog
    v-drag
    :title="editData.id ? '修改' : '新增'"
    :visible.sync="dialogVisible"
    width="800px"
    :show-close="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div class="content">
      <el-form ref="form" class="form" :model="form" :rules="rules">
        <div class="form-item">
          <label class="lable"><span class="red">* </span>类型</label>
          <el-form-item prop="portType">
            <el-radio-group v-model="form.portType" :disabled="editData.id">
              <el-radio :label="0">空运</el-radio>
              <el-radio :label="1">海运</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="form-item">
          <label class="lable">港口类型</label>
          <el-form-item prop="types">
            <el-checkbox-group v-model="form.types">
              <el-checkbox :label="0">始发港</el-checkbox>
              <el-checkbox :label="1">目的港</el-checkbox>
              <el-checkbox :label="2">清关港</el-checkbox>
              <el-checkbox :label="3">卸货港</el-checkbox>
            </el-checkbox-group>
            <!-- <el-radio-group v-model="form.types">
              <el-radio :label="0">始发港</el-radio>
              <el-radio :label="1">目的港</el-radio>
            </el-radio-group> -->
          </el-form-item>
        </div>
        <div class="form-item">
          <label class="lable"><span class="red">* </span>代码</label>
          <el-form-item prop="code">
            <el-input
              v-model="form.code"
              style="width: 320px"
              placeholder="请输入代码"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item">
          <label class="lable"><span class="red">* </span>中文名称</label>
          <el-form-item prop="nameCH">
            <el-input
              v-model="form.nameCH"
              style="width: 320px"
              placeholder="请输入备注内容"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item">
          <label class="lable"><span class="red">* </span>英文名称</label>
          <el-form-item prop="nameEN">
            <el-input
              v-model="form.nameEN"
              style="width: 320px"
              placeholder="请输入备注内容"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item">
          <label class="lable"><span class="red">* </span>地址</label>
          <el-form-item prop="address">
            <el-cascader
              ref="myCascader"
              v-model="form.address"
              style="width: 320px"
              placeholder="请选择地址"
              :options="addressDropCodeOption"
            >
            </el-cascader>
          </el-form-item>
        </div>
        <!-- <div class="form-item">
          <label class="lable">城市</label>
          <el-form-item prop="city">
            <el-input
              v-model="form.city"
              style="width: 320px"
              placeholder="请输入城市"
            ></el-input>
          </el-form-item>
        </div> -->
        <div class="form-item" style="width: 100%; margin-left: 0">
          <label class="lable">备注</label>
          <el-form-item prop="remark">
            <el-input
              v-model="form.remark"
              style="width: 660px"
              placeholder="请输入备注内容"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取 消</div>
      <div class="ok flex_c_c" @click="ok('form')">确 定</div>
    </span>
  </el-dialog>
</template>

<script>
import { insertHarbor, updateHarbor } from '@/api/basic'
import { mapGetters } from 'vuex'
export default {
  props: {
    dialogVisible: {
      types: Boolean,
      default: false
    },
    supplyService: {
      types: Array,
      default: function() {
        return []
      }
    },
    editData: {
      types: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      form: {
        portType: 0,
        types: [],
        code: '',
        nameCH: '',
        nameEN: '',
        address: '',
        remark: ''
      },
      rules: {
        portType: [{ required: true, message: '请选择类型', trigger: 'blur' }],
        types: [{ required: true, message: '请选择港口类型', trigger: 'blur' }],
        code: [{ required: true, message: '请输入代码', trigger: 'blur' }],
        nameCH: [{ required: true, message: '请输入中文名', trigger: 'blur' }],
        nameEN: [{ required: true, message: '请输入英文名', trigger: 'blur' }],
        address: [{ required: true, message: '请输入地址', trigger: 'blur' }]
      }
    }
  },
  computed: {
    ...mapGetters(['addressDropOption']),
    addressDropCodeOption() {
      return this.addressDropOption.map((item) => {
        return {
          value: item.value,
          label: `${item.label}`,
          children: item.children.map((a) => {
            return {
              label: a.label,
              value: a.value
            }
          })
        }
      })
    }
  },
  watch: {
    async dialogVisible() {
      if (this.editData.id) {
        // 确保地址数据已加载
        if (!this.addressDropOption || this.addressDropOption.length === 0) {
          await this.$store.dispatch('getAddress')
          // 等待 Vue 完成 DOM/响应式更新
          await this.$nextTick()
        }
        // 确保 addressDropCodeOption 已经更新
          const countryId = this.editData.countryId
          const provinceId = this.editData.provinceId

          // 安全检查
          const country = this.addressDropCodeOption.find(item => item.value === countryId)
          if (country && country.children) {
            const provinceExists = country.children.some(child => child.value === provinceId)
            console.log('Province exists:', provinceExists)
          } else {
            console.warn('Country not found or has no children')
          }

          this.form = {
            ...this.editData,
            address: [countryId, provinceId]
          }
      } else {
        this.form = {
          portType: 0,
          types: [],
          code: '',
          nameCH: '',
          nameEN: '',
          address: '',
          remark: '',
          catchGovCode: ''
        }
      }
    }
  },
  methods: {
    cancel() {
      this.$refs['form']?.resetFields()
      this.$emit('cancel')
    },
    ok(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            ...this.form,
            countryId: this.form.address[0],
            provinceId: this.form.address[1]
          }
          if (!this.editData.id) {
            insertHarbor(params).then((res) => {
              if (res.success) {
                this.$message.success('新增成功')
                this.$refs['form']?.resetFields()
                this.$emit('ok')
              } else {
                this.$message.error(res.errorMessage)
              }
            })
          } else {
            updateHarbor(params).then((res) => {
              if (res.success) {
                this.$message.success('修改成功')
                this.$refs['form']?.resetFields()
                this.$emit('ok')
              } else {
                this.$message.error(res.errorMessage)
              }
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  width: calc(100% - 120px);
  height: auto;
  margin: 0 auto;
  text-align: left;
  .form {
    display: flex;
    width: 100%;
    height: auto;
    flex-wrap: wrap;
  }
  .form-item {
    width: calc(50% - 20px);
    position: relative;
    .lable {
      width: 100%;
      height: 19px;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 20px;
      margin-bottom: 5px;
    }
    .red {
      color: rgba(255, 116, 68, 1);
    }
    &:nth-child(2n) {
      margin-left: 40px;
    }
  }
}
/deep/ .el-dialog__body {
  padding: 20px 20px;
}
.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 16px;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background:  rgb(18,88,188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}
</style>
